import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  TextField,
} from "@mui/material";

const PledgeStatusDialog = ({
  open,
  onClose,
  currentStatus,
  resourceId,
  apiPath,
  options = [],
  paymentMade: initialPayment,
  remainingAmount: initialRemaining,
}) => {
  const [status, setStatus] = useState(currentStatus);
  const [paymentMade, setPaymentMade] = useState(initialPayment || 0);
  const [remainingAmount, setRemainingAmount] = useState(initialRemaining || 0);
  const [loading, setLoading] = useState(false);

  // Reset values when dialog opens
  useEffect(() => {
    if (open) {
      setStatus(currentStatus);
      setPaymentMade(initialPayment || 0);
      setRemainingAmount(initialRemaining || 0);
    }
  }, [open, currentStatus, initialPayment, initialRemaining]);

  const handleUpdate = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}admin/${apiPath}/${resourceId}`,
        {
          method: "PUT", // change to PATCH if needed
          headers: {
            "Content-Type": "application/json",
            Authorization: `${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            status,
            paymentMade: Number(paymentMade),
            remainingAmount: Number(remainingAmount),
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Update failed");
      }

      alert("Updated successfully");
      onClose();
      window.location.reload(); // or use refresh from react-admin
    } catch (error) {
      console.error(error);
      alert(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Update Pledge</DialogTitle>

      <DialogContent style={{ display: "flex", flexDirection: "column", gap: 16, marginTop: 10 }}>

        {/* STATUS DROPDOWN */}
        <TextField
          select
          label="Status"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          fullWidth
        >
          {options.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>

        {/* PAID AMOUNT */}
        <TextField
          label="Paid Amount"
          type="number"
          fullWidth
          value={paymentMade}
          onChange={(e) => setPaymentMade(e.target.value)}
        />

        {/* REMAINING AMOUNT */}
        <TextField
          label="Remaining Amount"
          type="number"
          fullWidth
          value={remainingAmount}
          onChange={(e) => setRemainingAmount(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleUpdate}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PledgeStatusDialog;